import React, { useState, useEffect,useRef } from 'react';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1.jsx";
import Table1 from './Table1.jsx';
import Table2 from './Table2.jsx';
import Table3 from './Table3.jsx';
import { useGetPurchaseOrderListMutation } from '../../../../store/api/gateEntryApiNew'
import Tab2 from './Tab2.jsx';
import { useGetGenderOptionsQuery, useGetUserOptionsQuery, useGetSalutationOptionsQuery, useGetDocTypeOptionsQuery, useCreateContactMutation, useLazyGetContactByNameQuery } from '../../../../store/api/contactapi.jsx'
import Attachment from '../../../../utils/Attachment.jsx';

function Contact({ contact_id }) {
    const hasFetched = useRef(false);
    const actualContactId = contact_id?.contact_id?.trim();

    
    const [
        fetchContact,
        {
            data: contactDetails,
            isLoading: isContactLoading,
            error: contactError
        }
    ] = useLazyGetContactByNameQuery();

    useEffect(() => {
        if (!actualContactId || hasFetched.current) return;
        if (typeof actualContactId !== 'string' || actualContactId === '') return;

        console.log("Making API call with:", actualContactId);
        fetchContact(actualContactId);
        hasFetched.current = true;
    }, [actualContactId]);
    // In your Contact component

    useEffect(() => {
        if (contactDetails) {
            // Set basic form data
            setFormData({
                solution: contactDetails.salutation || '',
                firstname: contactDetails.first_name || '',
                lastname: contactDetails.last_name || '',
                gender: contactDetails.gender || '',
                userid: contactDetails.email_id || '',
                address: '', // Not in API response
                designation: contactDetails.designation || '',
                company_name: contactDetails.company_name || '',
                status: contactDetails.status || '',
                is_google: contactDetails.sync_with_google_contacts || false,
                unsubscribed: contactDetails.unsubscribed || false,
                department: contactDetails.department || '',
                is_primary_contact: contactDetails.is_primary_contact || false,
                is_billing_contact: contactDetails.is_billing_contact || false
            });

            // Set email data for Table1
            if (contactDetails.email_ids && contactDetails.email_ids.length > 0) {
                const emailRows = contactDetails.email_ids.map(email => ({
                    email: email.email_id || '',
                    is_primary: email.is_primary || false
                }));
                setselected_item_data(emailRows);
            }

            // Set phone data for Table2
            if (contactDetails.phone_nos && contactDetails.phone_nos.length > 0) {
                const phoneRows = contactDetails.phone_nos.map(phone => ({
                    number: phone.phone || '',
                    is_primary_phone: phone.is_primary_phone || false,
                    is_primary_mobile: phone.is_primary_mobile_no || false
                }));
                setselected_item_data_two(phoneRows);
            }

            // Set links data for Table3
            if (contactDetails.links && contactDetails.links.length > 0) {
                const linkRows = contactDetails.links.map(link => ({
                    Link_Document_Type: link.link_doctype || '',
                    Link_Name: link.link_name || ''
                }));
                setselected_item_data_three(linkRows);
            }
        }
    }, [contactDetails]);

    const [createContact, { isLoadingsix, errorsix, data }] = useCreateContactMutation();

    const [tab, settab] = useState(1);
    const [res, setRes] = useState(false);
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [ptype, setptype] = useState("Error");
    const [showError, setShowError] = useState(false);
    const [selected_item_data, setselected_item_data] = useState([]);
    const [selected_item_data_two, setselected_item_data_two] = useState([]);
    const [selected_item_data_three, setselected_item_data_three] = useState([]);
    const [getitem_list_data] = useGetPurchaseOrderListMutation();
    const [genderList, setGenderList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [salutationList, setsalutationList] = useState([]);
    const [doctypeList, setdoctypeList] = useState([]);
    const { data: genders, isLoading, errortwo } = useGetGenderOptionsQuery();
    const { data: users, isLoadingthrre, errorthree } = useGetUserOptionsQuery();
    const { data: salutation, isLoadingfour, errorfour } = useGetSalutationOptionsQuery();
    const { data: doctype, isLoading: isLoadingfive, error: errorfive, refetch } = useGetDocTypeOptionsQuery();
    useEffect(() => {
        if (genders) {
            setGenderList(genders.data)
        }
        if (users) {

            setUserList(users.data)
        }
        if (salutation) {

            setsalutationList(salutation.data)
        }
        if (doctype) {

            setdoctypeList(doctype.data)
        }
    }, [genders, users, salutation]);
    const [formData, setFormData] = useState({
        solution: '',
        firstname: '',
        lastname: '',
        gender: '',
        userid: '',
        address: '',
        designation: '',
        company_name: '',
        status: '',
        is_google: false,
        unsubscribed: false,
        department: '',
        is_primary_contact: false,
        is_billing_contact: false

    });
    const handleInputChange = (fieldName, value) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    const validateForm = () => {
        const newErrors = {};

        // Tab1 validations
        if (!formData.solution) newErrors.solution = "Salutation is required";
        if (!formData.firstname) newErrors.firstname = "First name is required";
        if (!formData.lastname) newErrors.lastname = "Last name is required";
        if (!formData.gender) newErrors.gender = "Gender is required";
        if (!formData.userid) {
            newErrors.userid = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.userid)) {
            newErrors.userid = "Invalid email format";
        }
        if (!formData.address) newErrors.address = "Address is required";
        if (!formData.designation) newErrors.designation = "Designation is required";
        if (!formData.company_name) newErrors.company_name = "Company name is required";
        if (!formData.status) newErrors.status = "Status is required";

        // Tab2 validations
        if (!formData.department) newErrors.department = "Department is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        const payload = {
            first_name: formData.firstname,
            last_name: formData.lastname,
            email_id: formData.userid,
            status: formData.status,
            salutation: formData.solution,
            designation: formData.designation,
            gender: formData.gender,
            mobile_no: selected_item_data_two?.find(e => e.is_primary_mobile)?.number || "",
            company_name: formData.company_name,
            is_primary_contact: formData.is_primary_contact ? 1 : 0,
            is_billing_contact: formData.is_billing_contact ? 1 : 0,
            department: formData.department,
            unsubscribed: formData.unsubscribed ? 1 : 0,
            email_ids: selected_item_data.map(e => ({
                email_id: e.email,
                is_primary: e.is_primary ? 1 : 0
            })),
            phone_nos: selected_item_data_two.map(e => ({
                phone: e.number,
                is_primary_phone: e.is_primary_phone ? 1 : 0,
                is_primary_mobile_no: e.is_primary_mobile ? 1 : 0
            })),
            links: selected_item_data_three.map(e => ({
                link_doctype: e.Link_Document_Type,
                link_name: e.Link_Name
            }))
        };

        try {
            // const response = 0
            const response = await createContact(payload).unwrap();
            console.log("Contact Created:", response);

            setError('Warehouse created successfully!');
            setptype('Success');
            setShowError(true);
        } catch (err) {
            console.error("Creation Failed:", err);
            setError('Failed to create contact.');
            setptype('Error');
            setShowError(true);
        }

        console.log('Formatted payload submitted');
    };
    console.log(contactDetails?.status,"contactDetails_741");
    
    return (
        <>
            <FormLayoutTwo
                title="View Contact"
                breadcrumbs={[
                    { label: "Master" },
                    { label: "Contact ", url: "/master/contact-list" }
                ]}
                status={contactDetails?.status}
                actionButtons={
                    <>
                        {/* <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >
                            Save
                        </Button> */}

                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                    <a className={tab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => settab(1)} href="javascript:void(0);">
                                        General Details {tab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                             <Attachment doctype="Contact"  docname={contact_id}  />    
                        </div>
                    </div>
                    <div className=" " style={{ background: '' }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="sidebarbox m-0">
                                    <Tab1
                                        contact_id={contact_id}
                                        salutationList={salutationList}
                                        genderList={genderList}
                                        userList={userList}
                                        formData={formData}
                                        onInputChange={handleInputChange}
                                        errors={errors}
                                        selected_item_data={selected_item_data}
                                        setselected_item_data={setselected_item_data}
                                        initialData={contactDetails?.email_ids?.map(email => ({
                                            email: email.email_id,
                                            is_primary: email.is_primary
                                        }))}
                                        selected_item_data_two={selected_item_data_two}
                                        setselected_item_data_two={setselected_item_data_two}
                                        initialData_two={contactDetails?.phone_nos?.map(phone => ({
                                            number: phone.phone,
                                            is_primary_phone: phone.is_primary_phone,
                                            is_primary_mobile: phone.is_primary_mobile_no
                                        }))}
                                        doctypeList={doctypeList}
                                        refetch={refetch}
                                        list_data={getitem_list_data}
                                        selected_item_data_three={selected_item_data_three}
                                        setselected_item_data_three={setselected_item_data_three}
                                        initialData_three={contactDetails?.links?.map(link => ({
  Link_Document_Type: link.link_doctype || '',
  Link_Name: link.link_name || '',
  Link_Title: link.link_name || ''   // add this
}))}
                                        

                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    );
}

export default Contact;
